import styled from 'styled-components';
import { gray10, white } from '@spotify-internal/encore-foundation';
export default styled.label.withConfig({
  displayName: "Label",
  componentId: "sc-1wl7d8t-0"
})(["color:", ";"], function (props) {
  return props.theme.formGroup === 'dark' ? white : gray10;
});